export const getFeedbackResponseSelector = state => state.feedbackResponse;
export const getSurveyConfigSelector = state => state.surveyConfig;